import { isBindingContextLoaded } from "../../../common/module-guard";

import { DefaultCanvasRect3dRender } from "./rect3d-render";

import { GraphicRender, Rect3DRender } from "./symbol";

const loadedRect3dModuleContexts = new WeakSet;

export function bindRect3dRenderModule({bind: bind}) {
    isBindingContextLoaded(loadedRect3dModuleContexts, bind) || (bind(DefaultCanvasRect3dRender).toDynamicValue((() => new DefaultCanvasRect3dRender)).inSingletonScope(), 
    bind(Rect3DRender).toService(DefaultCanvasRect3dRender), bind(GraphicRender).toService(Rect3DRender));
}

export const rect3dModule = bindRect3dRenderModule;
//# sourceMappingURL=rect3d-module.js.map
